const refineChartData = ({ data, config }) => {
  // loading chart
  if (data && data.length > 0) {
    const sortedData = data
      .slice()
      .sort(function (a, b) {
        if (a.event && b.event) {
          const dateA = a.event ? new Date(a.event.date): new Date(a.date);
          const dateB = b.event ? new Date(b.event.date): new Date(b.date);
          return dateA < dateB ? -1 : 1;
        } else {
          return -1;
        }
      })
      .reverse()
      .slice(0, 5)
      .sort(function (a, b) {
        if (a.event && b.event) {
          const dateA = a.event ? new Date(a.event.date): new Date(a.date);
          const dateB = b.event ? new Date(b.event.date): new Date(b.date);
          return dateA < dateB ? -1 : 1;
        } else {
          return -1;
        }
      });
    //refine data for chart
    const refinedData = {
      id: 'CHARTDATA',
      data: []
    };
    sortedData.forEach((element, index) => {
      if (!element.event) {
        element.event = {
          date: element.date,
          short_name: element.country && element.country.iso3 ? element.country.iso3 : ''
        }
      }
      const event = {
        x: `${element.event.short_name} ${new Date(element.event.date)
          .getFullYear()
          .toString()
          .slice(2, 4)}-->${index}<--`,
        y: null,
      };

      event.entryType = `${element.result}`;
      event.y = 0;

      if (
        !isNaN(element.result) &&
        element.finished_event &&
        element.result <= config.resultChartRange
      ) {
        const myResult = parseInt(element.result);
        event.y = Math.abs(config.resultChartRange - 1 - myResult);
        event.entryType = `${myResult}.`;
      } else if (typeof element.result === 'number' && element.finished_event) {
        event.entryType = `${element.result}.`;
      } else if (element.result_type) {
        event.entryType = element.result_type.toString().toUpperCase();
      }
      refinedData.data.push(event);
    });

    return refinedData;
  }
  return false;
};

export { refineChartData };
